export default __webpack_public_path__ + "static/media/Rodrick-headshot.04ea6963.jpg";